import getApi from '../../api'

export const renameConversation = (ulid: string, title: string) =>
  getApi().patch<void>(`/stats_assistant/conversations/${ulid}`, { title })
